import React from "react";

export function TextField({ label, value, onChange, placeholder, testId, type = "text" }) {
  return (
    <label className="block">
      <div className="eyebrow mb-2">{label}</div>
      <input
        data-testid={testId}
        type={type}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent border border-[color:var(--border)] focus:border-[color:var(--accent)] outline-none px-3 py-2.5 text-sm text-[color:var(--text)]"
      />
    </label>
  );
}

export function TextArea({ label, value, onChange, placeholder, testId, rows = 3 }) {
  return (
    <label className="block">
      <div className="eyebrow mb-2">{label}</div>
      <textarea
        data-testid={testId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className="w-full bg-transparent border border-[color:var(--border)] focus:border-[color:var(--accent)] outline-none px-3 py-2.5 text-sm text-[color:var(--text)] resize-y"
      />
    </label>
  );
}

export function Toggle({ label, value, onChange, testId }) {
  return (
    <label className="flex items-center justify-between gap-4 cursor-pointer py-2">
      <span className="eyebrow">{label}</span>
      <button
        type="button"
        data-testid={testId}
        onClick={() => onChange(!value)}
        className={`w-11 h-6 rounded-full transition-colors relative ${value ? "bg-[color:var(--accent)]" : "bg-[color:var(--border)]"}`}
      >
        <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white transition-transform ${value ? "translate-x-5" : ""}`} />
      </button>
    </label>
  );
}

export function AdminButton({ children, onClick, variant = "primary", testId, type = "button", disabled = false }) {
  const cls = variant === "primary" ? "btn-primary" : variant === "danger" ? "!bg-red-900/50 !text-red-200 hover:!bg-red-800" : "btn-outline";
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testId} className={`btn-pill ${cls} disabled:opacity-50`}>
      {children}
    </button>
  );
}

export function Section({ title, children, actions }) {
  return (
    <section className="mb-10">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-display italic text-3xl md:text-4xl leading-tight">{title}</h2>
        {actions}
      </div>
      {children}
    </section>
  );
}
